import type { ActionFlowNode, FlowNodeResultADT, StationMessageActionConfig, StationMessageActionConfigure } from '@lighthouse/shared'
import { generateVariableValue, resolvedUpstreamVariableValue } from '@lighthouse/shared'
import { safeToString } from '@lighthouse/tools'
import { t } from 'i18next'

import * as srv from '@/services'

import type { ExecuteActionParams } from '../type'

export const handleStationMessage = async (
    node: ActionFlowNode<StationMessageActionConfigure>,
    params: ExecuteActionParams
): Promise<undefined | FlowNodeResultADT> => {
    const {
        data: { config }
    } = node

    if (!config) {
        throw new Error(t('configurationNotPerfect'))
    }

    const { title, content, addresseeIds: configPersons } = config

    const addresseeIds = resolvedUpstreamVariableValue({ data: configPersons, extraParams: params })
    const titleValue = generateVariableValue({
        innerType: 'TEXT',
        jsonContent: title,
        extraParams: params,
        options: { format: true, useFileUrl: true }
    })
    const contentValue = generateVariableValue({
        innerType: 'TEXT',
        jsonContent: content,
        extraParams: params,
        options: { format: true, useFileUrl: true }
    })

    const isSuccess = await srv.activeStationMessageAction({
        addresseeIds,
        title: safeToString(titleValue),
        content: safeToString(contentValue)
    })

    return {
        type: 'record',
        success: isSuccess
    }
}
